import classNames from "classnames";
import PendingOrdersIcon from "../../images/pending-orders-icon.svg";
import React from "react";
import styles from "./PendingOrdersButton.module.css";
import {useAppSelector} from "../../lib/hooks";

const strings = {
    viewDriveThruOrders: (numOrders: number) =>
        `View Pending Order: ${numOrders}`,
    viewKioskOrders: (numOrders: number) =>
        `View Kiosk Cash Order: ${numOrders}`,
};

type Props = {
    className?: string;
    disabled?: boolean;
    onClick: () => void;
};

export default function PendingOrdersButton(props: Props) {
    const stationMode = useAppSelector((state) => state.pos.station.mode);
    const showKioskOrdersText =
        stationMode === "front_of_house_1" ||
        stationMode === "front_of_house_2";

    const pendingOrderCount = useAppSelector(
        (state) => Object.keys(state.pos.pendingOrders.byId).length,
    );

    return (
        <button
            className={classNames(props.className, styles.pendingOrdersButton)}
            disabled={
                props.disabled ||
                (stationMode !== "drive_thru_order_fulfillment" &&
                    pendingOrderCount === 0)
            }
            onClick={props.onClick}>
            <img src={PendingOrdersIcon} alt="" />
            <span className={styles.pendingOrdersButtonText}>
                {showKioskOrdersText
                    ? strings.viewKioskOrders(pendingOrderCount)
                    : strings.viewDriveThruOrders(pendingOrderCount)}
            </span>
        </button>
    );
}
